import { render, staticRenderFns } from "./AnamnesiViewPage.vue?vue&type=template&id=23eb815a&scoped=true"
import script from "./AnamnesiViewPage.vue?vue&type=script&lang=js"
export * from "./AnamnesiViewPage.vue?vue&type=script&lang=js"
import style0 from "./AnamnesiViewPage.vue?vue&type=style&index=0&id=23eb815a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb815a",
  null
  
)

export default component.exports